import React, { Suspense } from "react";

type IconLoaderProps = {
  name: string;
  className?: string;
  [key: string]: unknown;
};

function loadIcon(name: string) {
  type IconModule = Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>>;
  return React.lazy(() =>
    import("lucide-react").then((mod) => ({ default: (mod as IconModule)[name] }))
  );
}

export default function IconLoader({ name, className, ...rest }: IconLoaderProps) {
  const Icon = loadIcon(name);

  return (
    <Suspense fallback={<span style={{ display: "inline-block", width: 20, height: 20 }} /> }>
      <Icon className={className} {...rest} />
    </Suspense>
  );
}
